/* ============================================================
   BASICARE — shared interactions: animated sky, header,
   reveal-on-scroll, mobile menu, contact-form confirm

   ── Shopify テーマ版としての変更点 ──────────────────────
   本体サイト（basicare.co.jp）の sky.js を土台にしていますが、
   Shopify のテーマエディタ対応のため以下を変更しています。
   本体側から再コピーする際は、この変更を再適用してください。

   1. DOM に依存する初期化（ヘッダー追従・reveal-on-scroll・モバイルメニュー）を
      「何度呼んでも安全な関数」に切り出し、`window.BASICARE` から呼べるようにした
   2. ファイル末尾で `shopify:section:load` / `shopify:section:unload` を購読し、
      セクションが差し替わったときに再初期化するようにした

   ※ 1 が無いと、テーマエディタでセクションを追加・並べ替えした直後に
     IntersectionObserver が新要素を監視できず、`.rv` が opacity:0 のまま
     永久に表示されない状態になります。
   ============================================================ */
window.BASICARE = window.BASICARE || {};

(function(){
  /* ---- header scrolled state ---- */
  function initHeader(){
    var hd=document.getElementById('hd');
    if(!hd || hd.dataset.scrollBound) return;
    hd.dataset.scrollBound='1';
    function sync(){hd.classList.toggle('scrolled',scrollY>40);}
    addEventListener('scroll',sync,{passive:true});
    sync();
  }

  /* ---- reveal on scroll（取りこぼし防止の堅牢化：IO＋スクロールsweepの二重化） ----
     IntersectionObserver は高速フリック時にコールバックを取りこぼすことがあり、
     中間セクションが表示されないまま残る場合がある。加えて要素高がビューポートの
     約7倍を超えると threshold 到達不能で永久に隠れる。両方を sweep で確実に解消する。 */
  var rvs=[];
  var io=null;
  if('IntersectionObserver' in window){
    io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);var k=rvs.indexOf(e.target);if(k>-1)rvs.splice(k,1);}});
    },{threshold:.14});
  }
  function rvSweep(){
    var vh=window.innerHeight||document.documentElement.clientHeight;
    for(var i=rvs.length-1;i>=0;i--){
      var r=rvs[i].getBoundingClientRect();
      if(r.top < vh*0.9 && r.bottom > 0){ rvs[i].classList.add('in'); rvs.splice(i,1); }
    }
  }
  /* root 配下の未登録 .rv を監視対象に追加する（何度呼んでもよい） */
  function registerReveals(root){
    var scope=root||document;
    [].slice.call(scope.querySelectorAll('.rv')).forEach(function(el){
      if(el.dataset.rvBound) return;
      el.dataset.rvBound='1';
      rvs.push(el);
      if(io) io.observe(el);
    });
    rvSweep();
  }
  addEventListener('scroll',function(){if(rvs.length)rvSweep();},{passive:true});
  addEventListener('resize',function(){if(rvs.length)rvSweep();},{passive:true});
  addEventListener('load',rvSweep);

  /* ---- mobile menu ---- */
  function initMobileMenu(){
    var mb=document.querySelector('.menu-btn'), mn=document.querySelector('.mnav');
    if(!mb||!mn||mb.dataset.menuBound) return;
    mb.dataset.menuBound='1';
    mb.setAttribute('aria-expanded','false');
    function open(){mn.classList.add('open');mb.setAttribute('aria-expanded','true');}
    function close(){mn.classList.remove('open');mb.setAttribute('aria-expanded','false');}
    mb.addEventListener('click',open);
    mn.querySelectorAll('a,.close').forEach(function(a){a.addEventListener('click',close)});
    addEventListener('keydown',function(e){if(e.key==='Escape'&&mn.classList.contains('open'))close();});
  }

  /* ---- contact form confirm (no backend) ---- */
  function initContactForm(){
    var form=document.getElementById('contactForm');
    if(!form||form.dataset.bound) return;
    form.dataset.bound='1';
    form.addEventListener('submit',function(ev){
      ev.preventDefault();
      var note=document.getElementById('formNote');
      if(!form.checkValidity()){form.reportValidity();return;}
      if(note){note.style.display='block';note.scrollIntoView({behavior:'smooth',block:'center'});}
    });
  }

  /* ---- 何度でも呼べる初期化のまとめ ---- */
  function initAll(root){
    initHeader();
    initMobileMenu();
    initContactForm();
    registerReveals(root);
  }
  initAll(document);

  window.BASICARE.initAll=initAll;
  window.BASICARE.registerReveals=registerReveals;

  /* ---- テーマエディタ：セクション差し替えへの追従 ----
     shopify:section:load はテーマエディタでのみ発火します（実際の閲覧者には影響しません）。
     編集中はアニメーションの再生を待たずに即座に見えたほうが都合がよいため、
     読み込まれたセクション内の .rv は最初から表示状態にします。 */
  document.addEventListener('shopify:section:load',function(e){
    var sec=e.target;
    if(sec&&sec.querySelectorAll){
      [].slice.call(sec.querySelectorAll('.rv')).forEach(function(el){
        el.dataset.rvBound='1';
        el.classList.add('in');
      });
    }
    initAll(sec);
  });

  /* ---- animated starfield ---- */
  var cv=document.getElementById('sky'); if(!cv) return;
  var ctx=cv.getContext('2d');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var COLORS=['255,255,255','220,232,255','255,243,216','255,224,180','198,224,255'];
  var W,H,DPR,stars=[],shoot=[],sy=0,t0=performance.now();
  function init(){
    DPR=Math.min(devicePixelRatio||1,2);
    W=cv.width=Math.floor(innerWidth*DPR); H=cv.height=Math.floor(innerHeight*DPR);
    cv.style.width=innerWidth+'px'; cv.style.height=innerHeight+'px';
    var n=Math.max(150,Math.round(innerWidth*innerHeight/4200));
    stars=[];
    for(var i=0;i<n;i++){
      var layer=Math.random();
      stars.push({
        x:Math.random()*W, y:Math.random()*H,
        r:(Math.random()*1.0+0.35)*DPR*(0.7+layer*0.9),
        base:0.30+Math.random()*0.6,
        sp:0.5+Math.random()*1.9, ph:Math.random()*6.283,
        drift:(0.06+layer*0.16)*DPR,
        col:COLORS[(Math.random()*COLORS.length)|0],
        layer:0.1+layer*0.55,
        glow:Math.random()>0.85
      });
    }
  }
  function spawnShoot(){
    if(reduce)return;
    var startX=Math.random()*W*0.85, startY=Math.random()*H*0.45;
    var ang=Math.PI*(0.12+Math.random()*0.10);
    var spd=(7+Math.random()*4)*DPR;
    shoot.push({x:startX,y:startY,vx:Math.cos(ang)*spd,vy:Math.sin(ang)*spd,life:0,max:48+Math.random()*26,len:(90+Math.random()*120)*DPR});
  }
  addEventListener('scroll',function(){sy=scrollY;},{passive:true});
  function frame(now){
    var t=(now-t0)/1000;
    ctx.clearRect(0,0,W,H);
    for(var i=0;i<stars.length;i++){
      var s=stars[i];
      var tw=s.base*(0.5+0.5*Math.sin(t*s.sp+s.ph));
      var x=(s.x+(reduce?0:t*s.drift*22))%W; if(x<0)x+=W;
      var y=(s.y - sy*DPR*s.layer*0.10)%H; if(y<0)y+=H;
      if(s.glow){
        var g=ctx.createRadialGradient(x,y,0,x,y,s.r*7);
        g.addColorStop(0,'rgba('+s.col+','+(tw*0.55)+')');
        g.addColorStop(1,'rgba('+s.col+',0)');
        ctx.fillStyle=g; ctx.beginPath(); ctx.arc(x,y,s.r*7,0,6.283); ctx.fill();
      }
      ctx.fillStyle='rgba('+s.col+','+tw+')';
      ctx.beginPath(); ctx.arc(x,y,s.r,0,6.283); ctx.fill();
    }
    for(var j=shoot.length-1;j>=0;j--){
      var o=shoot[j]; o.life++; o.x+=o.vx; o.y+=o.vy;
      var a=Math.sin(Math.PI*o.life/o.max);
      var hyp=Math.hypot(o.vx,o.vy);
      var tx=o.x-o.vx/hyp*o.len, ty=o.y-o.vy/hyp*o.len;
      var lg=ctx.createLinearGradient(o.x,o.y,tx,ty);
      lg.addColorStop(0,'rgba(255,250,235,'+(a*0.9)+')'); lg.addColorStop(1,'rgba(255,250,235,0)');
      ctx.strokeStyle=lg; ctx.lineWidth=1.6*DPR; ctx.lineCap='round';
      ctx.beginPath(); ctx.moveTo(o.x,o.y); ctx.lineTo(tx,ty); ctx.stroke();
      if(o.life>o.max)shoot.splice(j,1);
    }
    requestAnimationFrame(frame);
  }
  init(); addEventListener('resize',init);
  requestAnimationFrame(frame);
  if(!reduce) setInterval(function(){ if(Math.random()>0.35) spawnShoot(); },2800);
})();

/* ============================================================
   Intro moon — scroll-synced phase (満ち欠け)
   黄色い月がブランドセクション通過に合わせて
   三日月 → 満月 → 三日月 へと物理的に正しく欠ける。
   影は「暗い縁の半円 ＋ ターミネーター(楕円)」のパスで描画。
   ============================================================ */
(function(){
  var moon=document.getElementById('introMoon');
  if(!moon) return;
  var shadow=document.getElementById('im-shadow');
  if(!shadow) return;
  var R=50, ILMIN=0.18; // 両端の最小照度（細い三日月）

  // 影パスを生成（illum:0=新月→1=満月, waxing:true=右が満ちる）
  function shadowPath(illum,waxing){
    if(illum>=0.999) return '';            // 満月＝影なし
    if(illum<=0.001) return 'M0 -50A50 50 0 1 0 0 50A50 50 0 1 0 0 -50Z'; // 新月＝全影
    var rx=(R*Math.abs(1-2*illum)).toFixed(2);
    var limb,term;
    // waxing（満ちていく）＝右が点灯／影は左。waning＝左が点灯／影は右。
    if(waxing){ limb=0; term=(illum<0.5)?0:1; }
    else      { limb=1; term=(illum<0.5)?1:0; }
    return 'M0 '+(-R)+'A'+R+' '+R+' 0 0 '+limb+' 0 '+R+'A'+rx+' '+R+' 0 0 '+term+' 0 '+(-R)+'Z';
  }
  function apply(illum,waxing){
    shadow.setAttribute('d',shadowPath(illum,waxing));
    moon.style.setProperty('--glow',illum.toFixed(3)); // 欠けるほど発光を控える
  }

  // 動きを抑える設定では満月で固定
  if(matchMedia('(prefers-reduced-motion:reduce)').matches){ apply(1,true); return; }

  var ticking=false;
  function render(){
    ticking=false;
    var rect=moon.getBoundingClientRect();
    var vh=innerHeight||document.documentElement.clientHeight;
    // 月が快適に見える帯(画面の下85%→上15%)を 0→1 に正規化
    var center=rect.top+rect.height/2;
    var q=(vh*0.85-center)/(vh*0.70);
    if(q<0)q=0; else if(q>1)q=1;
    // 中央(q=0.5)で満月、両端で三日月。sinでなめらかに。
    var illum=ILMIN+(1-ILMIN)*Math.sin(q*Math.PI);
    apply(illum, q<0.5);
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(render); } }
  addEventListener('scroll',onScroll,{passive:true});
  addEventListener('resize',onScroll,{passive:true});
  render();
})();

/* ヘッダーピルの月：スクロール進捗で満ち欠け（時間ではなくスクロール量に連動） */
(function(){
  var moons=document.querySelectorAll('.pmoon');
  if(!moons.length) return;
  var D=13; // 月の直径(px)。site.css の .pmoon と一致させる
  var pending=false;
  function compute(){
    pending=false;
    var h=document.documentElement;
    var max=h.scrollHeight-h.clientHeight;
    var progress=max>0?(window.scrollY||h.scrollTop)/max:0;
    // 満ちる → 満月で一呼吸ホールド → 欠ける（L: 0=新月, 1=満月）
    var WAX_END=0.25, HOLD_END=0.45, L;
    if(progress<=WAX_END){ L=0.5+(progress/WAX_END)*0.5; }   // 上弦→満月
    else if(progress<=HOLD_END){ L=1; }                       // 満月を保持（一呼吸）
    else { L=1-(progress-HOLD_END)/(1-HOLD_END); }            // 満月→新月
    var x=(D*L).toFixed(2)+'px';
    for(var i=0;i<moons.length;i++){ moons[i].style.setProperty('--pmoon-x',x); }
  }
  function onScroll(){ if(!pending){ pending=true; requestAnimationFrame(compute); } }
  compute();
  addEventListener('scroll',onScroll,{passive:true});
  addEventListener('resize',onScroll,{passive:true});
})();
